import Drawer from '@/components/UI/drawer/Drawer';
import RequestVisit from '@/components/houses/_reusable/requestVisit/RequestVisit';
const RequestDrawer = ({
  open,
  onClose
}) => {
  return <Drawer open={open} onClose={onClose} data-sentry-element="Drawer" data-sentry-component="RequestDrawer" data-sentry-source-file="RequestDrawer.tsx">
      <RequestVisit open={open} onClose={onClose} data-sentry-element="RequestVisit" data-sentry-source-file="RequestDrawer.tsx" />
    </Drawer>;
};
export default RequestDrawer;